// 消息类型
export const messageTypeMap = [['UN_READ', '未读'], ['READ', '已读']]
